module.exports = __webpack_public_path__ + "static/img/phonebg.6628214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/phonebg.jpg
// module id = iCYF
// module chunks = 1